// removed by extract-text-webpack-plugin
module.exports = {"loading-animation":"_3yt6k4zrMCZa6GKUvJiFAC","icon":"_2O--ijlsHoYytYb07aY4-2","spin":"e2kzVP-CM71w3rLtjcJST"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/LoadingAnimation/styles.scss
// module id = 907
// module chunks = 18